import {Capacitor} from '@capacitor/core';

/**
 * Fixes the image path for Android devices during development.
 * Replaces 'localhost' with the appropriate site root URL.
 * @param croppedImage
 * @returns
 */
export function replaceLocalhostWithSiteRoot(croppedImage: string): string {
  let imageSrc = croppedImage;
  if (
    imageSrc &&
    process.env.NODE_ENV !== 'production' &&
    Capacitor.getPlatform() === 'android'
  ) {
    if (imageSrc.includes('localhost')) {
      imageSrc = imageSrc.replace(
        /http\:\/\/localhost\:\d+/,
        process.env.SITE_ROOT,
      );
    }
  }

  return imageSrc;
}
